import {useState} from 'react';

interface IMassOperationsMode {
    isMassOperationsMode: boolean,
    toggleMassOperationsMode: () => void,
    exitMassOperationsMode: () => void,
}

const useMassOperationsMode = (onClearSelection: () => void): IMassOperationsMode => {
    const [isMassOperationsMode, setIsMassOperationsMode] = useState(false);

    const toggleMassOperationsMode = () => {
        const nextMode = !isMassOperationsMode;

        setIsMassOperationsMode(nextMode);

        if (!nextMode) {
            onClearSelection();
        }
    };

    const exitMassOperationsMode = () => setIsMassOperationsMode(false);

    return {isMassOperationsMode, toggleMassOperationsMode, exitMassOperationsMode};
};

export default useMassOperationsMode;
